import "react-data-grid/lib/styles.css";
import DataGrid, { CellClickArgs } from "react-data-grid";
import React, { useEffect, useMemo } from "react";
import { TableViewContent } from "./styles";
import { useTableFile } from "./use-table-file";
import { useTextSelect } from "../../hooks";
import { useStore } from "../../context";
import { Footer } from "../../molecules";
import { utils } from 'xlsx';

export const TableView = () => {
  const { rows, columns, handleCellClick } = useTableFile();

  // Access highlights from the fileviewer store
  const highlights = useStore(({ file: f }) => f.highlights);

  useTextSelect();

  type Row = {
    _id: number;
  };
  const rowKeyGetter = (row: Row) => row._id;

  // Function to check if a specific cell should be highlighted
  const isCellHighlighted = (rowIndex: number, columnKey: string) => {
    const columnIndex = utils.decode_col(columnKey);
    const isHighlighted = highlights.some(highlight => {
      const matches = highlight.head === rowIndex && highlight.tail === columnIndex;
      return matches;
    });
    return isHighlighted;
  };

  // Apply class to the actual grid cell using column.cellClass
  // Use useMemo to ensure columns update when highlights change, forcing DataGrid to re-render
  const columnsWithHighlighting = useMemo(() => {
    return columns.map(col => ({
      ...col,
      cellClass: (row: any) => {
        const rowIndex = rows.indexOf(row);
        const highlighted = isCellHighlighted(rowIndex, col.key);
        return highlighted ? 'highlighted-cell' : undefined;
      }
    }));
  }, [columns, rows, highlights]);

  return (
    <>
      <TableViewContent>
        <DataGrid
          className="rdg-light"
          columns={columnsWithHighlighting}
          rows={rows}
          style={{ flex: 1 }}
          rowKeyGetter={rowKeyGetter}
          onCellClick={handleCellClick}
        />
      </TableViewContent>
      <Footer />
    </>
  );
};
